export const actionTypes = {
  GET_PRODUCTS_REQUEST: "GET_PRODUCTS_REQUEST",
  GET_PRODUCTS_SUCCESS: "GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FAIL: "GET_PRODUCTS_FAIL",

  GET_PRODUCT_REQUEST: "GET_PRODUCT_REQUEST",
  GET_PRODUCT_SUCCESS: "GET_PRODUCT_SUCCESS",
  GET_PRODUCT_FAIL: "GET_PRODUCT_FAIL",

  GET_CATEGORIES_REQUEST: "GET_CATEGORIES_REQUEST",
  GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAIL: "GET_CATEGORIES_FAIL",

  GET_SEARCH_REQUEST: "GET_SEARCH_REQUEST",
  GET_SEARCH_SUCCESS: "GET_SEARCH_SUCCESS",
  GET_SEARCH_FAIL: "GET_SEARCH_FAIL",

  GET_ORDERS_REQUEST: "GET_ORDERS_REQUEST",
  GET_ORDERS_SUCCESS: "GET_ORDERS_SUCCESS",
  GET_ORDERS_FAIL: "GET_ORDERS_FAIL",

  DELETE_ORDER_REQUEST: "DELETE_ORDER_REQUEST",
  DELETE_ORDER_SUCCESS: "DELETE_ORDER_SUCCESS",
  DELETE_ORDER_FAIL: "DELETE_ORDER_FAI",

  CART_ADD_ITEM: "CART_ADD_ITEM",
  CART_REMOVE_ITEM: "CART_REMOVE_ITEM",
  CART_INCREASE_ITEM: "CART_INCREASE_ITEM",
  CART_DECREASE_ITEM: "CART_DECREASE_ITEM",

  CLEAR_CART: "CLEAR_CART",

  LOAD_REQUEST: "LOAD_REQUEST",
  LOAD_SUCCESS: "LOAD_SUCCESS",
  LOAD_FAIL: "LOAD_FAIL",

  REGISTER_REQUEST: "REGISTER_REQUEST",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAIL: "REGISTER_FAIL",

  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",

  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",

  LOGOUT_FAIL: "LOGOUT_FAIL",
};
